import { useMutation } from 'react-query'
import { createFeedback } from '../../api/feedbacks'

export function useCreateFeedbackMutation() {
  return useMutation(createFeedback)
}
